import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Moment from 'moment';
import DatePicker from "react-datepicker";
 
import "react-datepicker/dist/react-datepicker.css";

import CommError from '../../Shared/Errors/Errors'

import './CreateEditHoliday.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        paddingTop: '0px',
        background: 'white'
    }
}

let paragraphStyle = {
    backgroundColor: "white"
}

// Modal.setAppElement('body');

class CreateEditHoliday extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            holidayDate: props.create ? props.curHoliday.holidayDate : props.tmpHoliday.holidayDate
        };

        this.onDateChange = this.onDateChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.create !== prevProps.create 
        || this.props.curHoliday.holidayDate !== prevProps.curHoliday.holidayDate 
        || this.props.tmpHoliday.holidayDate !== prevProps.tmpHoliday.holidayDate) {
            this.setState({
                holidayDate: this.props.create ? this.props.curHoliday.holidayDate : this.props.tmpHoliday.holidayDate
            });
        }
    }

    onDateChange(date) {
        this.setState({
            holidayDate: date
        });

        this.props.valuesCheck();
    }

    render() {
        const {
            errHoliday,
            errHolidayClear,
            holidayTypes,
            curHoliday,
            tmpHoliday,
            viewMode,
            create,
            isOpen,
            valuesCheck,
            onAfterOpen,
            onRequestClose,
            onRequestCancel
        } = this.props;

        return (
            <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestClose={onRequestClose} style={styling}>
                <CommError error={errHoliday.error} onClose={errHolidayClear} />

                <div className="create-edit-holiday productManagement">
                    {viewMode ?
                        <h1>View Holiday</h1>
                        : <h1>{create ? 'Edit' : 'Create'} Holiday</h1>
                    }

                    <p style={paragraphStyle}>*= Required to Submit</p>
                    <div>
                        { create ? 
                            <div className="form-group">
                                <label>Holiday ID: </label>
                                    <span id="holiday_id">{create ? curHoliday.id : null}</span>
                            </div> : null
                        }
                        <div className="form-group">
                            <label htmlFor="holiday_name">Name:*</label>
                            <input type="text" className="form-control" id="holiday_name" autocomplete="off" onBlur={valuesCheck} disabled={viewMode ? true : false} defaultValue={create ? curHoliday.name : tmpHoliday.name} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="holiday_date">Date:*</label>
                            <DatePicker
                                id="holiday_date"
                                style={{ display: "block" }}
                                className="form-control"
                                disabled={viewMode ? true : false}
                                onChange={this.onDateChange}
                                selected={Moment(this.state.holidayDate).toDate()}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="holiday_type">Holiday Type:*</label>
                            <select id="holiday_type" disabled={viewMode ? true : false} onChange={valuesCheck} defaultValue={create ? curHoliday.holidayTypeId : tmpHoliday.holidayTypeId} className="multibox supp form-control">
                                <option value="0">Select</option>
                                {
                                    
                                    holidayTypes ? holidayTypes.holiday_types.map((holidayType, index) => {
                                        return <option value={holidayType.holidayTypeId} key={index}>
                                            {holidayType.holidayTypeName}
                                        </option>;
                                    }) : null
                                }
                            </select>
                        </div>
                        <div className="form-group">
                            <label htmlFor="holiday_message">Message:*</label>
                            <textarea className="form-control" id="holiday_message" disabled={viewMode ? true : false} onChange={valuesCheck} defaultValue={create ? curHoliday.message : tmpHoliday.message} />
                        </div>
                    </div>
                    <div className="form-group">
                        <a className="btn btn-default" onClick={onRequestCancel} >Cancel</a>&nbsp;
                        <button className="btn btn-primary modbrick" create={create ? "false" : "true"} onClick={onRequestClose}>Submit</button>
                    </div>
                </div>
            </Modal>
        );

    }
}
        
export default CreateEditHoliday